import { DpdExportRepeaterSettingsField } from './dpd-export-repeater-settings-field';
import dpdParcelshopShippingMethod from './dpd-parcelshop-shipping-method';
import dpdParcelshopAdminValidation from './dpd-parcelshop-shipping-method-admin-validation';

window.DpdParcelshopShippingMethodWeightByPackageRepeater = class extends (
	DpdExportRepeaterSettingsField
) {
	constructor(el) {
		super(el);
	}

	renderRow(inputData = []) {
		return `
			<li class="repeatable-field__row">
					<div class="repeatable-field__row-wrap">
							<span>
									<label for="${this.props.inputName}_min[]">
										${'minWeightInputText' in this.props ? this.props.minWeightInputText : ''}
									</label>

									<input
											class="repeatable-field__input form-field"
											data-ref="input-min"
											type="number"
											min="1"
											name="${this.props.inputName}_min[]"
											value="${'min' in inputData ? inputData.min : ''}"
											placeholder="${
												'minWeightInputPlaceholderText' in this.props
													? this.props.minWeightInputPlaceholderText
													: ''
											}"
									/>
							</span>

							<span>
									<label for="${this.props.inputName}_max[]">
											${'maxWeightInputText' in this.props ? this.props.maxWeightInputText : ''}
									</label>

									<input
											class="repeatable-field__input form-field"
											data-ref="input-max"
											type="number"
											min="1"
											name="${this.props.inputName}_max[]"
											value="${'max' in inputData ? inputData.max : ''}"
											placeholder="${
												'maxWeightInputPlaceholderText' in this.props
													? this.props.maxWeightInputPlaceholderText
													: ''
											}"
									/>
							</span>

							<span>
									<label for="${this.props.inputName}_price[]">
											${'priceInputText' in this.props ? this.props.priceInputText : ''}
									</label>

									<input
											class="repeatable-field__input form-field"
											data-ref="input-price"
											type="number"
											min="0"
											name="${this.props.inputName}_price[]"
											value="${'price' in inputData ? inputData.price : ''}"
											placeholder="${
												'priceInputPlaceholderText' in this.props
													? this.props.priceInputPlaceholderText
													: ''
											}"
									/>
							</span>


							<button
									class="repeatable-field__remove-button button"
									data-ref="removeButton"
									type="button"
									>
									${this.props.removeLabel ?? 'Remove'}
							</button>
					</div>
			</li>
		`;
	}
};

jQuery(document.body).on('wc_backbone_modal_loaded', function (evt, target) {
	if ('wc-modal-shipping-method-settings' === target) {
		document
			.querySelectorAll('[data-component="field-repeater"]')
			.forEach((el) => {
				const fieldRepeater =
					new window.DpdParcelshopShippingMethodWeightByPackageRepeater(el);
				fieldRepeater.init();
			});

		// init shipping method scripts
		dpdParcelshopShippingMethod.init();

		// init admin validation scripts
		dpdParcelshopAdminValidation.init();
	}
});
